import axios from "axios";

const instance = axios.create();

// Response interceptor for API calls
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      let { idToken } = JSON.parse(sessionStorage.getItem("msal_token"));
      axios.defaults.headers.common["Authorization"] = `Bearer ${idToken}`;
      return instance(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default instance;
